import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import AsyncStorage from '@react-native-async-storage/async-storage';
import combineReducers from '../reducers/combineReducers';

const persistConfig = {
  key: 'root',
  storage: AsyncStorage,
  whitelist: ['counter','user','inspection','uiVersion'],
  blacklist: [],
};

const persistedReducer = persistReducer(persistConfig, combineReducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: false,
  }),
});

const persistor = persistStore(store);

// const cleanAndLogout = async () => {
//   store.dispatch(cleanDataAuth());
// };

export { store, persistor };
